import Service, { service } from '@ember/service';
import { HOST } from 'scaleflow/adapters/application';

export default class DatasetFetcherService extends Service {
  @service store;
  @service session;
  adapter = this.store.adapterFor('initiative');

  get fetchOptions() {
    return {
      headers: {
        Authorization: this.session.accessToken,
        'Tenant-Id': this.session.data.authenticated.details?.tenant_id,
      },
    };
  }

  async fetchData(endpoint) {
    const res = await fetch(`${HOST}/datasets/${endpoint}`, {
      method: 'GET',
      ...this.fetchOptions,
    });
    const data = await res.json();
    return data;
  }

  fetchInitiativesDataset(roadmap) {
    if (roadmap.initiatives.length === 0)
      return Promise.resolve({ source: undefined });
    return this.adapter.findInitiativesForRoadmapDataset(roadmap);
  }
}
